import { Link } from "react-router-dom";
import { format } from "date-fns";
import { Check } from "lucide-react";
import Navbar from "../../components/lac/Navbar";
import Footer from "../../components/lac/Footer";

const slotToBlockRange = (slot) => {
  if (["09:00", "10:00", "11:00"].includes(slot)) return "9am – 12pm";
  if (["12:00", "13:00", "14:00"].includes(slot)) return "12pm – 3pm";
  if (["15:00", "16:00", "17:00"].includes(slot)) return "3pm – 6pm";
  return slot;
};

export default function BookingSuccess({ name, service, bookingDate, timeSlot, email }) {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar />
      <div className="max-w-2xl mx-auto px-6 pt-40 pb-32 text-center" data-testid="booking-success">
        <div className="w-20 h-20 mx-auto rounded-full bg-[#D946EF]/10 border border-[#D946EF]/40 flex items-center justify-center pulse-glow">
          <Check className="w-9 h-9 text-[#D946EF]" strokeWidth={2.5} />
        </div>
        <h1 className="mt-8 font-display font-bold text-4xl sm:text-5xl tracking-tighter">Booking received.</h1>
        <p className="mt-5 text-zinc-400 font-body">
          Thanks <span className="text-white font-medium">{name}</span> — we've got your <span className="neon-cyan">{service}</span> request for{" "}
          <span className="text-white font-medium">{format(bookingDate, "EEEE d MMM yyyy")}</span> in the <span className="text-white font-medium">{slotToBlockRange(timeSlot)}</span> block.
          We'll send a confirmation to <span className="text-white">{email}</span>.
        </p>
        <div className="mt-10 flex justify-center gap-4">
          <Link to="/" data-testid="success-home-btn" className="px-7 py-3 rounded-full border border-white/15 text-white hover:border-[#D946EF]/60 transition">Back home</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
